


























































































































import {Component, Vue} from "vue-property-decorator";
import {getTaskExcel, getTaskList, getConfig, suspendTask, sendBackTask, applyTask, getTaskTodayCount} from '@/services/api'
import store from "@/store";
import Task from "@/model/Task";

@Component({
  // components: {'zf-breadcrumb': breadcrumb},
})
export default class TaskList extends Vue {
  // 控制列表高度
  public tableHeight = window.innerHeight - 200;
  // 日期
  public date: string[] = [];
  // 上传表单
  public formData: {
    taskKey?: string,
    userId?: number,
    startDate?: string,
    endDate?: string,
    status?: number,
    pageNo: number,
    pageSize: number
  } = {
    pageNo: 1,
    pageSize: 20
  }
  // 列表总数
  public totalNum = 0
  // 列表数据
  public tableData: Task[] = []
  // 状态字典
  public statusList: {code: string, name: string}[] = [];
  // 今日提交、暂存列表
  public todayCountsList: {oldProduct: number, newProduct: number}[] = [];
  // excel下载截流控制
  public excelCtrl = true;

  public pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    window.onresize = () => {
      try {
        this.tableHeight = window.innerHeight - 200;
      } catch (e) {}
    }
    await this.getTaskList();
    this.getConfig();
    this.getTaskTodayCount();
  }

  /**
   * 获取item列表
   */
  async getTaskList(): Promise<void> {
    this.formData.startDate = this.date && this.date[0];
    this.formData.endDate = this.date && this.date[1];
    await getTaskList(this.formData, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.tableData = res.data.data.list || [];
        this.totalNum =  res.data.data.total || 0;
      }
    }).catch(() => {})
  }

  /**
   * 获取字典信息
   */
  getConfig(): void {
    if (!this.$store.state.statusList || this.$store.state.statusList.length === 0) {
      getConfig({type: 'task_status'}).then(res => {
        if (res.data && res.data.code === 200) {
          this.statusList = res.data.data || [];
          store.commit('SET_STATUS_LIST', this.statusList);
        }
      })
    } else {
      this.statusList = this.$store.state.statusList;
    }
  }

  getTaskTodayCount() {
    getTaskTodayCount().then(res => {
      if (res.data && res.data.code === 200) {
        this.todayCountsList = res.data.data.datas;
      }
    })
  }

  async apply(): Promise<void> {
    await applyTask({}, true).then(res => {
      if (res.data.code === 200) {
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    });
    await this.getTaskList();
  }

  async suspendTask(id: number): Promise<void> {
    await suspendTask({id}, true).then(res => {
      if (res.data.code === 200) {
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    });
    await this.getTaskList();
  }

  async sendBackTask(id: number): Promise<void> {
    await sendBackTask({id}, true).then(res => {
      if (res.data.code === 200) {
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    });
    await this.getTaskList();
  }

  /**
   * 编辑
   * @param i 索引
   * @param e 当前item
   */
  edit(i: number, e: any): void {
    window.open('/edit/modify/' + e.itemId,'_blank')
  }

  /**
   * 复制
   * @param i 索引
   * @param e 当前item
   */
  copy(i: number, e: any): void {
    window.open('/edit/copy/' + e.itemId,'_blank')
  }

  /**
   * 查询
   */
  search(): void {
    this.formData.pageNo = 1;
    this.getTaskList();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.formData.pageSize = val;
    this.formData.pageNo = 1;
    this.getTaskList();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.formData.pageNo = val;
    this.getTaskList();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank')
  }

  /**
   * excel下载
   */
  async getTaskExcel(): Promise<void> {
    if (this.excelCtrl) {
      this.excelCtrl = false;
      try{
        await getTaskExcel(this.formData).then((res:any) => {
          const blob = new Blob(
            [res.data], { type: 'application/vnd.ms-excel; chartset=utf-8'})
          const aEle = document.createElement('a');     // 创建a标签
          const href = window.URL.createObjectURL(blob);       // 创建下载的链接
          aEle.href = href;
          aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
          document.body.appendChild(aEle);
          aEle.click();     // 点击下载
          document.body.removeChild(aEle); // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
      } catch (e) {
        console.log(e)
      }
      this.excelCtrl = true;
    }

  }
}

